/**
 * Static Ads — `/ads/static`
 *
 * Consumer surface for the Static Ad Generator (graduated from the admin gate). Renders the shared
 * <StaticAdGenerator/> — the same component `/admin/static-ads` uses — so admin + consumer never
 * drift. The "paste your URL → get ads" wedge lives here.
 *
 * @feature-spec brain/vidmax/feature-specs/ads-static.md
 */
import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { z } from "zod"

import { zScrapedContentId } from "@aix/vidmax-shared/src/types/branded"

import CustomHead from "~/components/SEOHead/CustomHead"
import { StaticAdGenerator } from "~/components/StaticAds/StaticAdGenerator"
import AppLayout from "~/layouts/AppLayout"

function StaticAdsPage() {
  const { inspirationIds } = Route.useSearch()
  const navigate = useNavigate({ from: "/ads/static" })
  const initialInspirationContentIds = inspirationIds
    ? inspirationIds
        .split(",")
        .map((id) => zScrapedContentId.safeParse(id))
        .flatMap((result) => (result.success ? [result.data] : []))
        .slice(0, 3)
    : []

  return (
    <AppLayout>
      <CustomHead title="Static Ads" />
      <StaticAdGenerator
        initialInspirationContentIds={initialInspirationContentIds}
        onClearInspirations={() => void navigate({ to: "/ads/static", search: {}, replace: true })}
      />
    </AppLayout>
  )
}

export const Route = createFileRoute("/ads/static")({
  validateSearch: z.object({ inspirationIds: z.string().optional() }),
  component: StaticAdsPage,
})
